import React from 'react'
import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import { ColumnStartOrder, ColumnBib, ColumnPty, ColumnRank, ColumnRankNoType, ColumnName, ColumnNoc, ColumnResult, ColumnDifference, ColumnExpander } from "components/common/TableColumns"

function ColumnTime(){
  return (
    {
        Header: <Label data="HeaderTime" />,
        className: 'text-end',
        headerClassName: 'text-end w-10',
        disableSortBy: true,
        id: 'Time',
        Cell: (props) => {
          return props.cell.row.original?.extendedResults?.find(er => er?.er_code === 'INTERMEDIATE' && er?.er_pos === 'F')?.er_value2
        }
    }
  )  
}

export function TableColumnsStartList() {
  return (
      [
        ColumnStartOrder({}),
        ColumnBib({}),
        ColumnNoc({}),
        ColumnName({}),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsStartListSM() {
  return (
      [
        ColumnBib({ disableSort: true, accesor: 'startSortOrder' }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsLive() {
  return (
      [
          ColumnRankNoType({}),
          ColumnStartOrder({}),
          ColumnBib({}),
          ColumnNoc({}),
          ColumnName({}),
          ColumnTime(),
          ColumnPty({disableSort: true, label: "HeaderPenaltySecondsR"}),
          ColumnResult({disableSort: true, label:"HeaderTotal"}),
          ColumnDifference({disableSort: true}),
          ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsLiveSM() {
  return (
      [
        ColumnRankNoType({ disableSort: true }),
        ColumnBib({ disableSort: true }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnResult({disableSort: true, label:"HeaderTime"}),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}

export function TableColumnsFinish() {
  return (
      [
        ColumnRankNoType({}),
        ColumnStartOrder({}),
        ColumnBib({}),
        ColumnNoc({}),
        ColumnName({}),
        ColumnTime(),
        ColumnPty({disableSort: true, label: "HeaderPenaltySecondsR"}),
        ColumnResult({disableSort: true, label:"HeaderTotal"}),
        ColumnDifference({disableSort: true}),
        ColumnExpander({ type: 'alwaysTrue' })
    ]
  )
}

export function TableColumnsFinishSM() {
  return (
      [
        ColumnRankNoType({ disableSort: true }),
        ColumnBib({ disableSort: true }),
        ColumnNoc({ disableSort: true }),
        ColumnName({ disableSort: true }),
        ColumnResult({disableSort: true, label:"HeaderTime"}),
        ColumnExpander({ type: 'alwaysTrue' })
      ]
  )
}
